module.exports = __webpack_public_path__ + "static/img/proctor-edu.2329611.svg";